import NavSideBar from "../component/NavSideBar";

export default function Button() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Button</div>
    </NavSideBar>
  )
}
